import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { ref: "widget" }
const _hoisted_2 = { class: "ButtonText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isFullProfile)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.incentiveClicked && _ctx.incentiveClicked(...args))),
          class: "ButtonContentSwitcherWidget js-Widget",
          ref: "widget"
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "IconWrapper" }, [
            _createElementVNode("div", { class: "BestfitIcon" }, [
              _createElementVNode("i", { class: "Percentage lnr-bestfit-logo" }),
              _createElementVNode("i", { class: "PlusIcon lnr-plus-inverted" })
            ])
          ], -1 /* HOISTED */)),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.fitText), 1 /* TEXT */)
        ], 512 /* NEED_PATCH */))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}